import { useState, useEffect, useRef } from 'react';
import { useIsMounted } from 'shared/hooks/useIsMounted';

export const useIsElementOnScreen = (options) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const isMounted = useIsMounted();

  const callbackFunction = (entries) => {
    const [entry] = entries;
    if (isMounted()) {
      setIsVisible(entry.isIntersecting);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [containerRef, options]);

  return { containerRef, isVisible };
};
